export interface AccountActionResult {
  message?: string;
  Message?: string;
}

export const accountActionMessage = (
  result: AccountActionResult | undefined,
  fallback: string,
): string => result?.message || result?.Message || fallback;

export const accountActionError = (
  error: unknown,
  fallback: string,
): string => {
  type ActionError = { description?: string; Description?: string } | string;
  const data = (
    error as {
      response?: {
        data?: AccountActionResult & {
          errors?: ActionError[];
          Errors?: ActionError[];
        };
      };
    }
  )?.response?.data;
  const errors = Array.isArray(data) ? data : (data?.errors ?? data?.Errors);
  const descriptions = Array.isArray(errors)
    ? errors
        .map((item) =>
          typeof item === "string"
            ? item
            : (item.description ?? item.Description),
        )
        .filter(Boolean)
        .join(" ")
    : "";
  return descriptions || accountActionMessage(data, fallback);
};

export const parseAccountActionLink = (search: string) => {
  const params = new URLSearchParams(search);
  return {
    userId: params.get("userId")?.trim() ?? "",
    token: params.get("token")?.trim() ?? "",
  };
};
